import React from 'react';
import { Text, View } from 'react-native';
import { makeStyles, useAppTheme } from '../../theme/ThemeContext';

type AvatarProps = {
  name?: string | null;
  size?: number;
  /** 'ink' = Airbnb dark avatar, 'brand' = GeoFleete blue, 'soft' = tinted. */
  variant?: 'ink' | 'brand' | 'soft' | 'primary';
};

export function initialsOf(name?: string | null) {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0].charAt(0);
  const second = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return `${first}${second}`.toUpperCase();
}

/** Round initials avatar. */
export default function Avatar({ name, size = 40, variant = 'ink' }: AvatarProps) {
  const styles = useStyles();
  const { colors } = useAppTheme();
  const palette = {
    ink: { bg: colors.ink, fg: colors.onInk },
    brand: { bg: colors.brand, fg: colors.onBrand },
    soft: { bg: colors.surfaceAlt, fg: colors.textPrimary },
    primary: { bg: colors.primarySoft, fg: colors.primary },
  }[variant];

  return (
    <View
      style={[styles.avatar, { width: size, height: size, borderRadius: size / 2, backgroundColor: palette.bg }]}
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
    >
      <Text style={[styles.text, { color: palette.fg, fontSize: Math.round(size * 0.38) }]}>{initialsOf(name)}</Text>
    </View>
  );
}

const useStyles = makeStyles(() => ({
  avatar: { alignItems: 'center', justifyContent: 'center' },
  text: { fontWeight: '700' },
}));
